import type { ReactNode } from "react";
import { Tag } from "@diametral/design-system/react";

import type { Tone } from "../lib/labels";

/**
 * A tag with a × button, like the DS `Tag onRemove`, but whose button is named in French and
 * after its item ("Retirer React") rather than a bare "Remove".
 */
export function RemovableTag({
  children,
  onRemove,
  removeLabel,
  tone,
  disabled,
}: {
  children: ReactNode;
  onRemove: () => void;
  removeLabel: string;
  tone?: Tone;
  disabled?: boolean;
}) {
  if (disabled) return <Tag tone={tone}>{children}</Tag>;
  return (
    <Tag tone={tone} className="ds-tag--removable">
      {children}
      <button type="button" className="ds-tag__remove" aria-label={removeLabel} onClick={onRemove}>
        ×
      </button>
    </Tag>
  );
}
